<template>
  <div class="logos">
    <div class="logo">
      <img src="../../assets/apply/lock.png" style="width:20px;height:24px" alt="">
      <div class="by">Powered by</div>
      <img src="https://master-shopvidi.s3.amazonaws.com/index_images/shop_logo%402x.png" style="height:16px" alt="">
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.logos{
  display: flex;
  justify-content: center;
  .logo{
      display: flex;
      align-items: center;
      .by{
          width: 80px;
          margin: 0 10px;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/components/payment-footer.vue